import type { ArticleMap, LocalizedArticle } from './types';
import { guideArticle } from './guide';
import { reviewArticle } from './review';
import { shippingArticle } from './shipping';
import { couponArticle } from './coupon';
import { warehouseArticle } from './warehouse';
import { sellerArticle } from './seller';
import { qcArticle } from './qc';
import { buyingArticle } from './buying';
import { categoriesArticle } from './product-categories';
import { safetyArticle } from './safety';

export type { ArticleContent, ArticleSection, LocalizedArticle } from './types';

export const articles: ArticleMap = {
  'usfans-spreadsheet-guide': guideArticle,
  'usfans-review': reviewArticle,
  'usfans-shipping-cost': shippingArticle,
  'usfans-coupon': couponArticle,
  'usfans-warehouse': warehouseArticle,
  'usfans-seller-guide': sellerArticle,
  'usfans-qc-guide': qcArticle,
  'usfans-buying-guide': buyingArticle,
  'usfans-product-categories': categoriesArticle,
  'usfans-safety': safetyArticle,
};

export const articleSlugs: string[] = [
  'usfans-spreadsheet-guide',
  'usfans-review',
  'usfans-shipping-cost',
  'usfans-coupon',
  'usfans-warehouse',
  'usfans-seller-guide',
  'usfans-qc-guide',
  'usfans-buying-guide',
  'usfans-product-categories',
  'usfans-safety',
];

export function getLocalizedArticle(
  slug: string,
  lang: string,
): LocalizedArticle | undefined {
  return articles[slug];
}

export function getArticleContent(
  slug: string,
  lang: string,
) {
  const localized = articles[slug];
  if (!localized) return undefined;
  const base = lang.split('-')[0];
  return localized[base] || localized.en;
}